export default () => {
    const toTop = document.querySelector('#to-top-btn');
	const heroScrollBtn = document.querySelector('#arrow-down');
    // const header = document.querySelector('#header.main-header');
    let y1 = 0;
	if (toTop) {
		const body = document.querySelector('body');
		window.addEventListener('scroll', function(e){
			let y = window.scrollY;
			// console.log(`scrolly = ${y}`);
			const toTopClass = toTop.getAttribute('class');
			// to top
			if ( y > 200) {
				if ( y1 - y < 0) {
					body.classList.remove('scroll-up'); // Down
					body.classList.add('scroll-down');
				} else if ( y1 - y > 0 ){
					body.classList.remove('scroll-down');
					body.classList.add('scroll-up'); // Up
				}
				if (toTopClass.indexOf('shown') == -1) {
					toTop.classList.add('shown');
					setTimeout( () => { toTop.classList.remove('shown'); }, 2000 )
				}
			} else {
				toTop.classList.remove('shown');
			}
			// Sticky header
			// if ( header ) {
			//     ( y > header.offsetTop ) ?  header.classList.add('sticky') : header.classList.remove('sticky');
			// }
			// show Navbar (CSS todo)
			y1 = y;
			
		});
	}
	if (heroScrollBtn) {
		const target = document.getElementById('scroll-header');
		if (target) {
			const targetTop = target.offsetTop;
			heroScrollBtn.addEventListener('click', ()=>{
				window.scroll(0, targetTop);
			});
		}
	}
}